export default __webpack_public_path__ + "static/media/schedule-campaign-2.4ff421ea.png";